$(document).ready(function(){
	var form = $('form#stripePayment');
	if(form.length) {
        var handler = initStripeHandler();

		form.find('#donate').click(function(event) {	
            event.preventDefault();              

            if(validate()) {            
                var amount = parseInt(form.find('input[name="amount"]').val());       
                openStripeDialog(amount);
            }            
		});
        
		window.addEventListener('popstate', function () {
			handler.close();
		});		        
        
        function validate() {                                    
            var ok = true;
            
            checkField('amount', function(value){
                return (parseInt(value) > 0);
            });
            checkField('name', function(value){
                return ($.trim(value) != '');
            });                       
            
            function checkField(name, validator) {
                var field = form.find('input[name="'+name+'"]');
                var group = field.closest('.form-group');
                var value = field.val();
                                                   
                if(validator(value)) { 
                    group.removeClass('has-error');                    
                }
                else {
                    group.addClass('has-error');
                    field.focus();
                    ok = false;                    
                }                
            }                                
            
            return ok;
        }
        
        function initStripeHandler() {
            var handler = StripeCheckout.configure({
                key: form.data('publishable-key'),
                image: '/assets/images/ecc_logo.png',                
                locale: 'en',
                token: function (token) {
                    form.find('input[name="token"]').val(token.id);
                    form.submit();
                }
            });   
            return handler;
        }
        
        function openStripeDialog(amount) {
			handler.open({
				name: 'European Cultural Centre',
				description: 'Donation for European Cultural Centre',
				amount: amount * 100,
				zipCode: false,
				billingAddress: false,
				currency: 'USD',
				panelLabel: 'Donate {{amount}}', 
				allowRememberMe: false
			});			      
        }
	}

});